import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _QUESTION_DISPLAY_NAM;
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AMBER, BLUE, GRAY, GREEN, RED } from '@applyboard/ui-components';
var TAG_THEMES = {
  negative: {
    color: RED[5],
    backgroundColor: RED[19]
  },
  negativeLight: {
    color: RED[5],
    backgroundColor: RED[20]
  },
  positive: {
    color: GREEN[5],
    backgroundColor: GREEN[19]
  },
  positiveLight: {
    color: GREEN[5],
    backgroundColor: GREEN[20]
  },
  primary: {
    color: BLUE[5],
    backgroundColor: BLUE[19]
  },
  secondary: {
    color: GRAY[5],
    backgroundColor: GRAY[19]
  },
  warning: {
    color: AMBER[5],
    backgroundColor: AMBER[20]
  }
};
export var DETAIL_TITLES = {
  // detail headers
  attribute: 'Attribute',
  template: 'Template',
  instance: 'Instance',
  // modified attributes title mappings
  requiredState: 'Required State',
  requiredStateEarlyAccess: 'Early Access Required State',
  requiresNotarization: 'Requires Notarization',
  maxPlagiarismScore: 'Plagiarism Check',
  maxPlagiarismCharCount: 'Maximum Character Count',
  minPlagiarismCharCount: 'Minimum Character Count',
  maxPlagiarismWordCount: 'Maximum Word Count',
  minPlagiarismWordCount: 'Minimum Word Count',
  fileUploadLimit: 'Single File Upload Limit',
  fileCategories: 'File Types',
  additionalAttachments: 'Additional Attachments',
  externalLinks: 'External Links',
  questions: 'Question',
  payment: 'Payment',
  internal: 'Internal',
  official: 'Official',
  applyproofCompatible: 'Applyproof Compatible',
  applyboardRequirement: 'Applyboard Requirement',
  title: 'Title',
  description: 'Description',
  internalTitle: 'Internal Title',
  internalDescription: 'Internal Description',
  flywire: 'Flywire',
  // modified attribute fields display mappings
  required_state_optional: 'Optional',
  required_state_required: 'Required'
};
export var QUESTION_FORMATS = /*#__PURE__*/function (QUESTION_FORMATS) {
  QUESTION_FORMATS["checkbox"] = "checkboxes";
  QUESTION_FORMATS["dropdown"] = "dropdown";
  QUESTION_FORMATS["shortAnswer"] = "short_answer";
  QUESTION_FORMATS["longAnswer"] = "long_answer";
  QUESTION_FORMATS["date"] = "date";
  QUESTION_FORMATS["url"] = "url";
  QUESTION_FORMATS["number"] = "number";
  return QUESTION_FORMATS;
}({});
export var QUESTION_DISPLAY_NAMES = (_QUESTION_DISPLAY_NAM = {}, _defineProperty(_QUESTION_DISPLAY_NAM, QUESTION_FORMATS.checkbox, 'Checkboxes'), _defineProperty(_QUESTION_DISPLAY_NAM, QUESTION_FORMATS.dropdown, 'Dropdown'), _defineProperty(_QUESTION_DISPLAY_NAM, QUESTION_FORMATS.shortAnswer, 'Short Answer'), _defineProperty(_QUESTION_DISPLAY_NAM, QUESTION_FORMATS.longAnswer, 'Long Answer'), _defineProperty(_QUESTION_DISPLAY_NAM, QUESTION_FORMATS.date, 'Date'), _defineProperty(_QUESTION_DISPLAY_NAM, QUESTION_FORMATS.url, 'Link'), _defineProperty(_QUESTION_DISPLAY_NAM, QUESTION_FORMATS.number, 'Number'), _QUESTION_DISPLAY_NAM);
export var TAG_ID_MAPPING = {
  // statuses
  status_no_status: {
    title: 'No Status',
    theme: TAG_THEMES.secondary
  },
  status_missing: {
    title: 'Missing',
    theme: TAG_THEMES.warning
  },
  status_reviewing: {
    title: 'Reviewing',
    theme: TAG_THEMES.primary
  },
  status_completed: {
    title: 'Completed',
    theme: TAG_THEMES.positive
  },
  status_not_approved: {
    title: 'Not Approved',
    theme: TAG_THEMES.negativeLight
  },
  status_inactive: {
    title: 'Inactive',
    theme: TAG_THEMES.secondary
  },
  // requirement tags
  manually_added: {
    title: 'Manually Added',
    theme: TAG_THEMES.positiveLight
  },
  modified: {
    title: 'Modified',
    theme: TAG_THEMES.secondary
  },
  manually_deactivated: {
    title: 'Manually Deactivated',
    theme: TAG_THEMES.negative
  },
  // theme is not required as the icons come with a background color by default
  // recording the correct themes here in case the icons are changed
  student_records: {
    title: 'This requirement will show up on Student Records',
    theme: TAG_THEMES.secondary
  },
  applyproof_compatible: {
    title: 'This requirement is Applyproof Compatible',
    theme: TAG_THEMES.secondary
  }
};